// import axios from "axios";
// import React, { useEffect, useMemo } from "react";
// import { useDispatch } from "react-redux";
// import axiosInstance from "../utils/axiosInstance";
// import {
//   Navigate,
//   useNavigate,
//   useParams,
//   useLocation,
// } from "react-router-dom";
// import { addAuth } from "../store/slices/authSlice";
// import { jwtDecode } from "jwt-decode";

// const ProtectedRoutes = ({ children }) => {
//   const accessToken = localStorage.getItem("accessToken");
//   const location = useLocation();

//   const refreshToken = localStorage.getItem("refreshToken");
//   // const { role } = useParams();
//   const allowedAdminPaths = [
//     "/administration",
//     "/users",
//     "/report",
//     "/adminquotes",
//     "/commissionReport",
//     "/requestApproval",
//     "/user-profile",
//     "/help&feedback",
//     "/support",
//     "/flaggedComment",
//     "/updateprofile",
//     "/disputes",
//   ];

//   const isAdminAllowed = useMemo(
//     () => allowedAdminPaths.some((pre) => location.pathname.startsWith(pre)),
//     [location.pathname]
//   );
//   const role = useMemo(() => {
//     if (!accessToken) return <Navigate to="/login" replace />;
//     try {
//       const decoded = jwtDecode(accessToken);
//       // console.log("Role from token-------:", decoded.role);
//       return decoded?.role ?? null;
//     } catch {
//       return null;
//     }
//   }, [accessToken]);
//   const navigate = useNavigate();
//   const dispatch = useDispatch();

//   useEffect(() => {
//     if (accessToken) {
//       (async () => {
//         try {
//           const response = await axiosInstance.get("/users/me");
//           const userStatus = response.data?.details?.user?.status;

//           if (
//             userStatus === "BLOCKED_BY_ADMIN" ||
//             userStatus === "BLOCKED_BY_CUSTOMER"
//           ) {
//             localStorage.clear();
//             navigate("/login");
//             return;
//           }

//           dispatch(
//             addAuth({
//               ...response.data.details,
//               accessToken,
//               refreshToken,
//             })
//           );
//         } catch (error) {
//           console.log("User verification failed:", error);
//           localStorage.clear();
//           navigate("/login");
//         }
//       })();
//     }
//   }, [dispatch, accessToken, refreshToken, navigate]);

//   useEffect(() => {
//     if (accessToken) {
//       const checkTokenExpiration = () => {
//         try {
//           const decoded = jwtDecode(accessToken);
//           const currentDate = new Date();
//           // console.log("Role from token-------:", decoded.role);
//           if (decoded.exp * 1000 < currentDate.getTime()) {
//             console.log("Token expired.");
//             localStorage.clear();
//             navigate("/login");
//           }
//         } catch (err) {
//           console.log("Token decode failed:", err);
//           localStorage.clear();
//           navigate("/login");
//         }
//       };

//       checkTokenExpiration();
//     }
//   }, [accessToken, navigate]);

//   if (!accessToken) {
//     return <Navigate to="/login" replace />;
//   }
//   // if (role === "ADMIN" && !allowedAdminPaths.includes(location.pathname)) {
//   if (role === "ADMIN" && !isAdminAllowed) {
//     return <Navigate to="/administration" replace />;
//   }
//   // if (role === "ADMIN" && !allowedAdminPaths.includes(location.pathname)) {
//   if (role === "ADMIN" && !isAdminAllowed) {
//     return <Navigate to="/administration" replace />;
//   }

//   return children;
// };

// export default ProtectedRoutes;

import React, { useEffect, useMemo } from "react";
import { useDispatch } from "react-redux";
import { Navigate, useNavigate, useLocation } from "react-router-dom";
import { jwtDecode } from "jwt-decode";
import axiosInstance from "../utils/axiosInstance";
import { addAuth } from "../store/slices/authSlice";

/* ------------------------------------------------------------------ */
/* 🚦  Wrapper to protect private routes                               */
/* ------------------------------------------------------------------ */
const ProtectedRoutes = ({ children }) => {
  /* ---------------------------------------------------------------- */
  /* 📦  Tokens & helpers                                              */
  /* ---------------------------------------------------------------- */
  const accessToken = localStorage.getItem("accessToken");
  const refreshToken = localStorage.getItem("refreshToken");

  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  /* ---------------------------------------------------------------- */
  /* 👑  Admin-allowed paths                                           */
  /* ---------------------------------------------------------------- */
  const allowedAdminPaths = [
    "/administration",
    "/users",
    "/report",
    "/document",
    "/adminquotes",
    "/commissionReport",
    "/requestApproval",
    "/user-profile",
    "/help&feedback",
    "/support",
    "/flaggedComment",
    "/updateprofile",
    "/disputes",
    "/orders",             // Allow dynamic e.g. /orders/304
  "/updateStatus",      // For QUOTE
  "/accept-order",      // For QUOTES
  "/requests",     
  "/docs",     // For REPLY, COMMENT
  "/requestDetails", 
  ];

  const isAdminAllowed = useMemo(
    () => allowedAdminPaths.some((p) => location.pathname.startsWith(p)),
    [location.pathname]
  );

  /* ---------------------------------------------------------------- */
  /* 🎫  Extract role from token                                       */
  /* ---------------------------------------------------------------- */
  const role = useMemo(() => {
    if (!accessToken) return null;

    if (!accessToken) return null;
    try {
      const decoded = jwtDecode(accessToken);
      console.log("[PROTECTED] 🎫 Role →", decoded.role);
      return decoded.role ?? null;
    } catch (err) {
      console.error("[PROTECTED] ❌ Token decode failed", err);
      return null;
    }
  }, [accessToken]);

  /* ---------------------------------------------------------------- */
  /* 🔍  Verify user status via /users/me                              */
  /* ---------------------------------------------------------------- */
  useEffect(() => {
    if (!accessToken) return;

    (async () => {
      console.log("[PROTECTED] 🔍 GET /users/me");
      try {
        const res = await axiosInstance.get("/users/me");
        const userStatus = res.data?.details?.user?.status;
        console.log("[PROTECTED] 👤 Status →", userStatus);

        /* blocked? → logout */
        if (["BLOCKED_BY_ADMIN", "BLOCKED_BY_CUSTOMER"].includes(userStatus)) {
          console.warn("[PROTECTED] 🚫 User blocked – forcing logout");
          localStorage.clear();
          navigate("/login");
          return;
        }

        /* save auth to Redux */
        dispatch(
          addAuth({
            ...res.data.details,
            accessToken,
            refreshToken,
          })
        );
      } catch (err) {
        console.error("[PROTECTED] ❌ Verification failed", err);
        localStorage.clear();
        navigate("/login");
      }
    })();
  }, [accessToken, refreshToken, dispatch, navigate]);

  /* ---------------------------------------------------------------- */
  /* 🕒  Local expiry double-check (edge-case for already expired)     */
  /* ---------------------------------------------------------------- */
  useEffect(() => {
    if (!accessToken) return;
    try {
      const { exp } = jwtDecode(accessToken);
      if (Date.now() > exp * 1000) {
        console.log(
          "[PROTECTED] 🕒 Token dikhta hai expire – waiting for refresh"
        );
      }
    } catch (err) {
      console.error("[PROTECTED] ❌ Decode fail", err);
    }
  }, [accessToken]);

  /* ---------------------------------------------------------------- */
  /* 🚧  Route guards                                                 */
  /* ---------------------------------------------------------------- */
  if (!accessToken) return <Navigate to="/login" replace />;
  if (role === "ADMIN" && !isAdminAllowed)
    return <Navigate to="/administration" replace />;

  /* ---------------------------------------------------------------- */
  /* ✅  All good – render children                                   */
  /* ---------------------------------------------------------------- */
  return children;
};

export default ProtectedRoutes;

// import axios from "axios";// import React, { useEffect, useMemo } from "react";
// import { useDispatch } from "react-redux";
// import { Navigate, useNavigate, useLocation } from "react-router-dom";
// import { addAuth } from "../store/slices/authSlice";
// import { jwtDecode } from "jwt-decode";

// const ProtectedRoutes = ({ children }) => {
//   const accessToken = localStorage.getItem("accessToken");
//   const refreshToken = localStorage.getItem("refreshToken");

//   const navigate = useNavigate();
//   const location = useLocation();
//   const dispatch = useDispatch();

//   const role = useMemo(() => {
//     if (!accessToken) return null;
//     try {
//       return jwtDecode(accessToken)?.role ?? null;
//     } catch {
//       return null;
//     }
//   }, [accessToken]);

//   useEffect(() => {
//     if (!accessToken) return;

//     const verify = async () => {
//       try {
//         const res = await axios.get(
//           `${process.env.REACT_APP_SERVER_URL}/users/me`,
//           { headers: { Authorization: `Bearer ${accessToken}` } }
//         );
//         dispatch(addAuth({ ...res.data.details, accessToken, refreshToken }));
//       } catch (err) {
//         console.error("User verify fail:", err);
//         localStorage.clear();
//         navigate("/login");
//       }
//     };
//     verify();
//   }, [accessToken, refreshToken, dispatch, navigate]);

//   useEffect(() => {
//     if (!accessToken) return;
//     try {
//       const { exp } = jwtDecode(accessToken);
//       if (Date.now() >= exp * 1000) {
//         localStorage.clear();
//         navigate("/login");
//       }
//     } catch {
//     }
//   }, [accessToken, navigate]);

//   if (!accessToken) {
//     return <Navigate to="/login" replace />;
//   }

//   if (role === "ADMIN" && location.pathname !== "/administration") {
//     return <Navigate to="/administration" replace />;
//   }

//   return children;
// };

// export default ProtectedRoutes;
